import { LOCALES } from './locales'

export const messages = {
  [LOCALES.ENGLISH]: {
    boardCreationBtn: 'Create board',
    edit: 'Edit profile',
    signOut: 'Sign out',
    signIn: 'Sign in',
    signUp: 'Sign up',
    delete: 'Delete',
    titleBoardPage: 'Boards',
    titleBoardCreation: 'Create new board',
    titleBoardUpdate: 'Update board',
    titleNewBoard: 'Board name',
    titleColumnCreation: 'Create new column',
    titleNewColumn: 'Column name',
    titleTaskCreation: 'Create new task',
    titleNewTask: 'Task name',
    DescriptionNewTask: 'Task description',
    decsriptionNewBoard: 'Decsription',
    create: 'Create',
    back: 'Back',
    placeholderTitleBoard: 'Enter board title',
    placeholderDecsriptionBoard: 'Enter board description',
    placeholderSignInLog: 'Enter your login',
    placeholderSignInPas: 'Enter your password',
    placeholderSignUpName:'Enter your name',
    placeholderConfirm: "Confirm your password",
    nameProject: 'Project Management App',
    dontHaveAccount: 'Don’t have an account?',
    haveAccount:'Already have an account?',
    enterAccount: 'Sign in to your account',
    enterSignUp: 'Join our community',
    deleteBoard: 'Do you really want to delete this board?',
    yes: 'Yes',
    no: 'No',
    addColumn: '+ Add Column',
    addTask: '+ Add task',
    login: 'Login',
    name: 'Name',
    password: 'Password',
    confirm: 'Confirm password',
    editTitle: 'Edit your profile information',
    cancel: 'Cancel',
    update: 'Update',
    deleteProfile: 'Delete Profile',
    close: 'Close',
    newColumn: 'New column',
    newTaskTitle: 'Enter task title',
    newTaskDescription: 'Enter task description',
    editTask: 'Edit task',
    saveTask: 'Save task',
    taskAssignee: 'Assignee',
    taskDate: 'Date',
    taskDescription: 'Description',
    errorColumn: '👨🏻‍🏫 * hey, bro, you need to type something',
    errorSignUpNameRequired: 'Name is required',
    errorSignUpNameMinLength: 'Name must be at least 2 characters',
    errorSignUpNameMaxLength: 'Name must not exceed 64 characters',
    errorSignUpNameLetters: 'Your name must contain only letters',
    errorLoginRequired: 'Login is required',
    errorLoginMinLength: 'Login must be at least 3 characters',
    errorLoginMaxLength: 'Login must not exceed 64 characters',
    errorPasswordRequired: 'Password is required',
    errorPasswordMinLength: 'Password must be at least 6 characters',
    errorPasswordMaxLength: 'Password must not exceed 128 characters',
  },
  [LOCALES.RUSSIAN]: {
    boardCreationBtn: 'Создать доску',
    edit:'Изменть профиль',
    signOut: 'Выйти',
    signIn: 'Войти',
    signUp: 'Регистрация',
    delete: 'Удалить',
    titleBoardPage: 'Доски',
    titleBoardCreation: 'Создать новую доску',
    titleBoardUpdate: 'Изменить доску',
    titleNewBoard: 'Имя доски',
    titleColumnCreation: 'Создать новую колонку',
    titleNewColumn: 'Имя колонки',
    titleTaskCreation: 'Создать новую задачу',
    titleNewTask: 'Имя задачи',
    DescriptionNewTask: 'Описание задачи',
    decsriptionNewBoard: 'Описание доски',
    create: 'Создать',
    back: 'Назад',
    placeholderTitleBoard: 'Введите название доски',
    placeholderDecsriptionBoard: 'Введите описание доски',
    placeholderSignInLog: 'Введите логин',
    placeholderSignInPas: 'Введите пароль',
    placeholderSignUpName:'Введите имя',
    placeholderConfirm: "Подтвердите пароль",
    nameProject: 'Приложение для управления проектами',
    dontHaveAccount: 'У Вас нет аккаунта?',
    haveAccount:'Уже есть аккаунт?', 
    enterAccount: 'Войдите в свой аккаунт',
    enterSignUp: 'Присоединяйся к нашему сообществу',
    deleteBoard: 'Вы правда хотите удалить доску?',
    yes: 'Да',
    no: 'Нет',
    addColumn: '+ Добавить колонку',
    addTask: '+ Добавить задачу',
    login: 'Логин',
    name: 'Имя',
    password: 'Пароль',
    confirm: 'Подтвердить пароль',
    editTitle: 'Измениние информации вашего профиля',
    cancel: 'Отмена',
    update: 'Обновить',
    deleteProfile: 'Удалить профиль',
    close: 'Закрыть',
    newColumn: 'Новая колонка',
    newTaskTitle: 'Введите название задачи',
    newTaskDescription: 'Введите описание задачи',
    editTask: 'Редактировать задачу',
    saveTask: 'Сохранить задачу',
    taskAssignee: 'Исполнитель',
    taskDate: 'Дата',
    taskDescription: 'Описание',
    errorColumn: '👨🏻‍🏫 * напиши что-нибудь',
    errorSignUpNameRequired: 'Имя обязательно',
    errorSignUpNameMinLength: 'Имя должно быть не менее 2 символов',
    errorSignUpNameMaxLength: 'Имя не должно превышать 64 символов',
    errorSignUpNameLetters: 'Ваше имя должно содержать только буквы',
    errorLoginRequired: 'Логин обязателен',
    errorLoginMinLength: 'Логин должен быть не менее 3 символов',
    errorLoginMaxLength: 'Логин не должен превышать 64 символов',
    errorPasswordRequired: 'Пароль обязателен',
    errorPasswordMinLength: 'Пароль должен быть не менее 6 символов',
    errorPasswordMaxLength: 'Пароль не должен превышать 64 символов',
  }
}